import Vue from 'vue'

// jQuert & Bootstrap
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery')
require('bootstrap')
require('jquery-mask-plugin')

// Axios
import axios from 'axios'
window.axios = axios

// Moment Js
import moment from 'moment-timezone'
window.moment = moment
window.clientTimeZone = moment.tz.guess();
Vue.prototype.$moment = window.moment;

// Lodash
import lodash from 'lodash'
window._ = lodash

// intlTelInput (Phone)
import intlTelInput from 'intl-tel-input'
window.intlTelInput = intlTelInput

// Flatpicker (Calendar)
import flatpickr from 'flatpickr'
window.flatpickr = flatpickr

// Pluralize strings
window.pluralize = require('pluralize')

// Dropzone
import Dropzone from 'dropzone';
window.Dropzone = Dropzone;

// Tagify
import Tagify from '@yaireo/tagify';
window.Tagify = Tagify;

// Storage
window.Storage = require('store')

// Video JS
window.VideoJs = require('video.js').default;

// Signature Pad
import SignaturePad from 'signature_pad';
window.SignaturePad = SignaturePad;

// PusherJS
import Pusher from 'pusher-js';
window.Pusher = Pusher;

// Setup Laravel Echo
import Echo from "laravel-echo"
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: config.pusherKey,
    cluster: config.pusherCluster,
    forceTLS: true
});

// Instant Search => Algolia vue-instantsearch
import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);